import { GetReservPar, PutReservation, Reservations, ReservCell } from 'entities/Reservations';

import {
  CLEAR_ERROR_BOOKINGS,
  GET_CELL_SETTINGS_ERROR,
  GET_CELL_SETTINGS_REQUEST,
  GET_CELL_SETTINGS_SUCCESS,
  GET_LOCKED_CELL_ERROR,
  GET_LOCKED_CELL_REQUEST,
  GET_LOCKED_CELL_SUCCESS,
  GET_MANAGER_BOOKS_ERROR,
  GET_MANAGER_BOOKS_REQUEST,
  GET_MANAGER_BOOKS_SUCCESS,
  POST_BOOK_ERROR,
  POST_BOOK_REQUEST,
  POST_BOOK_SUCCESS,
  POST_CELL_ERROR,
  POST_CELL_REQUEST,
  POST_CELL_SUCCESS,
  PUT_BLOCK_ALL_ERROR,
  PUT_BLOCK_ALL_REQUEST,
  PUT_BLOCK_ALL_SUCCESS,
  PUT_BLOCK_ERROR,
  PUT_BLOCK_REQUEST,
  PUT_BLOCK_SUCCESS,
  PUT_BOOK_ERROR,
  PUT_BOOK_REQUEST,
  PUT_BOOK_SUCCESS,
  PUT_EDIT_BOOK_ERROR,
  PUT_EDIT_BOOK_REQUEST,
  PUT_EDIT_BOOK_SUCCESS,
} from './constants';

export const getAllBooksRequest = (params: GetReservPar) => ({
  type: GET_MANAGER_BOOKS_REQUEST,
  params,
});
export const getAllBooksSuccess = (bookings: ReservCell[], unconfirmedBook: number) => ({
  type: GET_MANAGER_BOOKS_SUCCESS,
  payload: bookings,
  unconfirmedBook,
});
export const getAllBooksError = (error: Error | null) => ({
  type: GET_MANAGER_BOOKS_ERROR,
  payload: error,
});

export const putBookRequest = (data: PutReservation) => ({
  type: PUT_BOOK_REQUEST,
  payload: data,
});

export const putBookSuccess = () => ({
  type: PUT_BOOK_SUCCESS,
});
export const putBookError = (error: Error | null) => ({
  type: PUT_BOOK_ERROR,
  payload: error,
});

export const editBookRequest = (data: Reservations) => ({
  type: PUT_EDIT_BOOK_REQUEST,
  payload: data,
});
export const editBookSuccess = () => ({
  type: PUT_EDIT_BOOK_SUCCESS,
});
export const editBookError = (error: Error | null) => ({
  type: PUT_EDIT_BOOK_ERROR,
  payload: error,
});

export const postBookRequest = (data: any) => ({
  type: POST_BOOK_REQUEST,
  payload: data,
});
export const postBookSuccess = () => ({
  type: POST_BOOK_SUCCESS,
});
export const postBookError = (error: Error | null) => ({
  type: POST_BOOK_ERROR,
  payload: error,
});

export const postCellRequest = (
  checkInDate: string,
  checkOutDate: string,
  isBlocked: boolean = false,
  cellLockType: number,
) => ({
  type: POST_CELL_REQUEST,
  checkInDate,
  checkOutDate,
  isBlocked,
  cellLockType,
});
export const postCellSuccess = (book: ReservCell) => ({
  type: POST_CELL_SUCCESS,
  payload: book,
});
export const postCellError = (error: Error | null) => ({
  type: POST_CELL_ERROR,
  payload: error,
});

export const putCellBlockRequest = (cellId: string, isBlocked: boolean) => ({
  type: PUT_BLOCK_REQUEST,
  cellId,
  isBlocked,
});
export const putCellBlockSuccess = () => ({
  type: PUT_BLOCK_SUCCESS,
});
export const putCellBlockError = (error: Error | null) => ({
  type: PUT_BLOCK_ERROR,
  payload: error,
});

export const putCellBlockAllRequest = (date: string, isBlocked: boolean, comment: string) => ({
  type: PUT_BLOCK_ALL_REQUEST,
  date,
  isBlocked,
  comment,
});
export const putCellBlockAllSuccess = () => ({
  type: PUT_BLOCK_ALL_SUCCESS,
});
export const putCellBlockAllError = (error: Error | null) => ({
  type: PUT_BLOCK_ALL_ERROR,
  payload: error,
});

export const clearErrorBookings = () => ({
  type: CLEAR_ERROR_BOOKINGS,
});

export const getCellSettingsRequest = () => ({
  type: GET_CELL_SETTINGS_REQUEST,
});

export const getCellSettingsSuccess = (cellSettings: any) => ({
  type: GET_CELL_SETTINGS_SUCCESS,
  payload: cellSettings,
});

export const getCellSettingsError = (error: any) => ({
  type: GET_CELL_SETTINGS_ERROR,
  payload: error,
});

export const getLockedCellRequest = (params: GetReservPar) => ({
  type: GET_LOCKED_CELL_REQUEST,
  params,
});

export const getLockedCellSuccess = (lockedCell: any) => ({
  type: GET_LOCKED_CELL_SUCCESS,
  payload: lockedCell,
});

export const getLockedCellError = (error: any) => ({
  type: GET_LOCKED_CELL_ERROR,
  payload: error,
});

export type Actions =
  | ReturnType<typeof putCellBlockAllRequest>
  | ReturnType<typeof putCellBlockAllSuccess>
  | ReturnType<typeof putCellBlockAllError>
  | ReturnType<typeof putCellBlockRequest>
  | ReturnType<typeof putCellBlockSuccess>
  | ReturnType<typeof putCellBlockError>
  | ReturnType<typeof editBookRequest>
  | ReturnType<typeof editBookSuccess>
  | ReturnType<typeof editBookError>
  | ReturnType<typeof postCellRequest>
  | ReturnType<typeof postCellSuccess>
  | ReturnType<typeof postCellError>
  | ReturnType<typeof getAllBooksRequest>
  | ReturnType<typeof getAllBooksSuccess>
  | ReturnType<typeof getAllBooksError>
  | ReturnType<typeof putBookRequest>
  | ReturnType<typeof putBookSuccess>
  | ReturnType<typeof putBookError>
  | ReturnType<typeof postBookRequest>
  | ReturnType<typeof postBookSuccess>
  | ReturnType<typeof postBookError>
  | ReturnType<typeof getCellSettingsRequest>
  | ReturnType<typeof getCellSettingsSuccess>
  | ReturnType<typeof getCellSettingsError>
  | ReturnType<typeof getLockedCellRequest>
  | ReturnType<typeof getLockedCellSuccess>
  | ReturnType<typeof getLockedCellError>
  | ReturnType<typeof clearErrorBookings>;
